import type {ReactNode} from 'react';

export enum PublishingOptionsPerRow {
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
}

export interface PublishingOptionsGridSectionViewAll {
  count: number;
  isExpanded?: boolean;
  onClick: VoidFunction;
}

export interface PublishingOptionsGridSectionProps {
  itemsPerRow: PublishingOptionsPerRow;
  children: ReactNode;
  title: string;
  hasGradientHeading?: boolean;
  viewAllPublishingOptions?: PublishingOptionsGridSectionViewAll;
  expandableExtraItems?: ReactNode;
}
